import { HighlightedBannerSection, type BannerData } from '@components/display/banners';
import { handleError } from '@utils/common';
import { useLazyGetVideosQuery } from '@videos/services';
import { IVideoDto } from '@videos/types';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const HighlightedVideos = () => {
    const intl = useIntl();
    const [getVideos] = useLazyGetVideosQuery();

    const fetchPage = useCallback(
        async (page: number, pageSize: number) => {
            const response = await getVideos({
                page,
                page_size: pageSize,
                highlighted: true,
                requestCache: 'no-store',
            }).unwrap();

            return {
                count: response.count,
                results: response.results.map(
                    (video: IVideoDto): BannerData => ({
                        background: 'blue',
                        header_title: video.title,
                        header_text: video.description ?? '',
                        image: video.thumbnail,
                        image_alt: video.title,
                        loading: false,
                        video_id: video.youtube_video_id,
                    })
                ),
            };
        },
        [getVideos]
    );

    const onError = useCallback(
        (error: unknown) => {
            console.error('Error fetching highlighted videos:', error);
            handleError(
                intl.formatMessage({ id: 'videos.fetch.error', defaultMessage: 'Error fetching highlighted videos' }),
                error
            );
        },
        [intl]
    );

    return <HighlightedBannerSection fetchPage={fetchPage} onError={onError} className="pt-2 md:pt-4" />;
};
